import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PointHistoryLogApi } from 'api';
import type { PointHistoryLog } from 'api/methods/PointHistoryLogApi';

/**
 * [PointHistoryLog] Query key 생성
 * --
 */
export const pointHistoryLogQueryKeys = createQueryKeys(
  'point_history_log_log',
  {
    getPointHistoryLog: (
      idx: number,
      params?: { [key: string]: string | number }
    ) => [idx, params],
    getPointHistoryLogs: (params?: { [key: string]: string | number }) => [
      params,
    ],
  }
);

/**
 * [PointHistoryLog] 포인트 적립 내역 전체 조회
 * --
 */
export const useGetPointHistoryLogs = (
  params?: {
    [key: string]: string | number;
  },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: pointHistoryLogQueryKeys.getPointHistoryLogs(params).queryKey,
    queryFn: () => PointHistoryLogApi.getPointHistoryLogs(params),
    ...options,
  });
  return data;
};

/**
 * [PointHistoryLog] 포인트 적립 내역 상세 조회
 * --
 */
export const useGetPointHistoryLog = (
  idx: number,
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: pointHistoryLogQueryKeys.getPointHistoryLog(idx, params).queryKey,
    queryFn: () => PointHistoryLogApi.getPointHistoryLog(idx, params),
    ...options,
  });

  return data;
};

/**
 * [PointHistoryLog] 포인트 적립 내역 생성
 * --
 */
export const useCreatePointHistoryLog = () => {
  const { mutateAsync: createPointHistoryLog, ...result } = useMutation({
    mutationFn: (variables: PointHistoryLog) =>
      PointHistoryLogApi.createPointHistoryLog(variables),
  });

  return { createPointHistoryLog, ...result };
};

/**
 * [PointHistoryLog] 포인트 적립 내역 수정
 * --
 */
export const useUpdatePointHistoryLog = () => {
  const { mutateAsync: updatePointHistoryLog, ...result } = useMutation({
    mutationFn: (variables: PointHistoryLog) =>
      PointHistoryLogApi.updatePointHistoryLog(variables),
  });

  return { updatePointHistoryLog, ...result };
};

/**
 * [PointHistoryLog] 포인트 적립 내역 삭제
 * --
 */
export const useDeletePointHistoryLog = () => {
  const { mutateAsync: deletePointHistoryLog, ...result } = useMutation({
    mutationFn: (variables: number) =>
      PointHistoryLogApi.deletePointHistoryLog(variables),
  });

  return { deletePointHistoryLog, ...result };
};
